import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { TranslateModule } from '@ngx-translate/core';
import { ArticleFeatureVideoComponent } from '@shared/components/article-feature-video/article-feature-video.component';
import { EligibilityCheckDialogComponent } from '@shared/components/eligibility-check-dialog/eligibility-check-dialog.component';
import { EligibilityResultDialogComponent } from '@shared/components/eligibility-result-dialog/eligibility-result-dialog.component';
import { MemberRegistrationResultComponent } from '@shared/components/member-registration-result/member-registration-result.component';
import { ErrorDirective, ErrorsDirective } from '@shared/directives/errors';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { MaterialManifestModule } from '../material-manifest/material-manifest.module';
import { ActivateValidationErrorComponent } from './components/activate-validation-error/activate-validation-error.component';
import { BasicInfoDialogCrossComponent } from './components/basic-info-dialog-cross/basic-info-dialog-cross.component';
import { FilterModalComponent } from './components/filter-bar/components/filter-modal/filter-modal.component';
import { MessageBoxComponent } from './components/message-box/message-box.component';
import { OptionsDialogComponent } from './components/options-dialog/options-dialog.component';
import { PopupCanNotEditAddressComponent } from './components/popup-can-not-edit/popup-can-not-edit-address/popup-can-not-edit-address.component';
import { PopupCanNotEditEmailComponent } from './components/popup-can-not-edit/popup-can-not-edit-email/popup-can-not-edit-email.component';
import { PopupCanNotEditNumberComponent } from './components/popup-can-not-edit/popup-can-not-edit-number/popup-can-not-edit-number.component';
import { PopupEligibilityComponent } from './components/popup-eligibility/popup-eligibility.component';
import { DeletePopupComponent } from './components/popup-form/delete-popup/delete-popup.component';
import { PopupFormComponent } from './components/popup-form/popup-form.component';
import { VideoPopupComponent } from './components/video-popup/video-popup.component';

/**
 * Shared modules to be imported and exported.
 */
const modules = [
  CommonModule,
  FormsModule,
  MaterialManifestModule,
  ErrorDirective,
  ErrorsDirective,
  ReactiveFormsModule,
  RouterModule,
  TourMatMenuModule,
  TranslateModule,
  YouTubePlayerModule,
];

const standalones = [
  FilterModalComponent,
  ArticleFeatureVideoComponent,
  EligibilityCheckDialogComponent,
  EligibilityResultDialogComponent,
  MemberRegistrationResultComponent,
  ActivateValidationErrorComponent,
  BasicInfoDialogCrossComponent,
  DeletePopupComponent,
  MessageBoxComponent,
  OptionsDialogComponent,
  PopupCanNotEditAddressComponent,
  PopupCanNotEditEmailComponent,
  PopupCanNotEditNumberComponent,
  PopupEligibilityComponent,
  PopupFormComponent,
  VideoPopupComponent,
];

@NgModule({
  imports: [...modules, ...standalones],
  exports: [...modules, ...standalones],
})
export class SharedModule {}
